import {FC, PropsWithChildren, ReactNode} from 'react';
import {useNavigate} from 'react-router-dom';

import RoyalCaninIcon from '@common/icons/RoyalCanin';
import UserIcon from '@common/icons/UserIcon';
import useAuthenticationStore from '@common/stores/authenticationStore';
import HomeIcon from '@common/icons/HomeIcon';
import {selectUser} from '@common/stores/authenticationSelectors';

interface Props extends PropsWithChildren {
  breadcrumbs?: ReactNode;
}

const Header: FC<Props> = ({children, breadcrumbs}) => {
  const navigate = useNavigate();
  const user = useAuthenticationStore(selectUser);

  const handleHomeClick = () => {
    navigate('/products');
  };

  return (
    <div className="p-4 pl-10 flex justify-between items-center mr-5">
      <div className="flex items-end gap-6">
        <RoyalCaninIcon />
        <div className="flex flex-row items-center divide-x-2 divide-red  text-sm text-gray-link font-medium">
          <div className="flex flex-row items-center gap-2 cursor-pointer pr-2" data-tooltip-id="main-tooltip" data-tooltip-content="Return to Products Dashboard" onClick={handleHomeClick}>
            <HomeIcon />
            Home
          </div>
          <div className="pl-2">{breadcrumbs}</div>
        </div>
      </div>

      <div className="flex justify-between items-center gap-6">
        <div className="flex">{children}</div>

        <div className="flex">
          <div className="h-7 justify-start items-center gap-4 inline-flex">
            <div className="w-7 h-7 relative">
              <div className="w-7 h-7 left-0 top-0 absolute bg-red rounded-full flex items-center justify-center">
                <UserIcon className="w-4 h-4" />
              </div>
            </div>

            <div className="text-gray-text text-sm font-normal">
              {user.firstName} {user.lastName}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
